import type { TIrrigationZoneEmitter, TPoint } from 'stores/fieldAssetStore/helperTypes'
import { getPointExternalVendorNames } from './getPointExternalVendorNames'

export const getIrrigationZoneEmitterExternalVendorNames = ({
  irrigationZoneEmitter,
  points,
}: {
  irrigationZoneEmitter: Pick<TIrrigationZoneEmitter, 'externalVendorNames' | 'irrigationZoneEmitterId'>
  points: Pick<TPoint, 'externalVendorNamesByValueType' | 'irrigationEmitterZoneIds'>[]
}) => [
  ...new Set([
    ...(irrigationZoneEmitter.externalVendorNames ?? []),
    ...points
      .filter((point) =>
        point.irrigationEmitterZoneIds?.includes(irrigationZoneEmitter.irrigationZoneEmitterId),
      )
      .flatMap((point) => getPointExternalVendorNames({ point, deviceKind: 'irrigation' })),
  ]),
]
